import { render, staticRenderFns } from "./JadwalPraktekDokter.vue?vue&type=template&id=627d66fc"
import script from "./JadwalPraktekDokter.vue?vue&type=script&lang=js"
export * from "./JadwalPraktekDokter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports